import { twclsx } from "../../utils/cssUtil";

export function Loading({ className }: { className?: string }) {
  return (
    <div className={"p-2 w-full flex justify-center"}>
      <div
        className={twclsx(className, "loading loading-dots loading-xl")}
      ></div>
    </div>
  );
}
